import React, { useEffect, useState } from "react";
import { addDays, startOfMonth, endOfMonth, format } from "date-fns";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import RightArrow from "../../atoms/icons/right-arrow";

import { setDateParams, dialogueShow } from "../../helper/actions";
import { toBanglaMonth, getDateForCalendar, toMonthIndex, pushToUrlParams } from "../../utils/utils";

import "./calendar.m.css";

const Calendar = ({ isMobile = false, setDateParams, dialogueShow, dateParams }) => {
  const [currentMonth, setCurrentMonth] = useState("");
  const [selectedDate, setSelectedDate] = useState("");

  useEffect(() => {
    if (!dateParams) {
      setCurrentMonth("");
      setSelectedDate("");
    }
  }, [dateParams]);

  useEffect(() => {
    const search = window.location.search.substring(1);
    if (search) {
      const d = search.split("=")[1];
      const day = d.split("-")[0];
      const month = toMonthIndex(d.split("-")[1]);
      const date = new Date(2021, month, +day);

      setTimeout(() => {
        const ele = document.getElementById("calendar-day");
        ele.scrollBy(0, date.getDate() > 5 ? date.getDate() * 28 : 0);
        setCurrentMonth(date);
        setSelectedDate(date);
        setDateParams(date);
      }, 300);
    }
    return () => {
      if (!isMobile) {
        setDateParams("");
      }
    };
  }, []);

  const selectMonth = (month) => {
    setCurrentMonth(month);
  };

  const renderMonth = () => {
    const months = [];
    for (let count = 2; count <= 11; count++) {
      const month = new Date(2021, count, 1);
      months.push(
        <div
          key={count + month.getTime().toString()}
          styleName={`calendar-month-item ${
            currentMonth && currentMonth.getMonth() === month.getMonth() ? "active-month" : ""
          }`}
          onClick={() => selectMonth(month)}
        >
          <span styleName="calendar-month-name">{toBanglaMonth(month.getMonth() + 1)}</span>
          {currentMonth && currentMonth.getMonth() === month.getMonth() ? (
            <span styleName="calendar-month-icon normal">
              <RightArrow arrowColor="#fff" height="11" width="11" />
            </span>
          ) : (
            <span styleName="calendar-month-icon rotated">
              <RightArrow arrowColor="#000" height="11" width="11" />
            </span>
          )}
        </div>
      );
    }
    return months;
  };

  const onDateClick = (day) => {
    setSelectedDate(day);
    setCurrentMonth(day);
    setDateParams(day);

    const qs = "date=" + format(day, "d-MMM");
    pushToUrlParams(qs);

    if (isMobile) {
      dialogueShow(false);
    }
  };

  const renderDays = () => {
    const startMonth = currentMonth || new Date(2021, 2, 1);
    const monthStart = startOfMonth(startMonth);
    const monthEnd = endOfMonth(monthStart);
    const dateFormat = "d";
    const days = [];
    let day = monthStart;
    let formattedDate = "";
    while (day <= monthEnd) {
      formattedDate = format(day, dateFormat);
      const cloneDay = day;
      const today =
        selectedDate && selectedDate.getMonth() === day.getMonth() && selectedDate.getDate() === day.getDate();
      days.push(
        <div
          styleName={`calendar-day-name ${today ? "selected-date" : ""}`}
          key={day}
          onClick={(e) => {
            onDateClick(cloneDay);
          }}
        >
          <span>{getDateForCalendar(formattedDate)}</span>
        </div>
      );
      day = addDays(day, 1);
    }

    return <>{days}</>;
  };

  return (
    <div styleName={`calendar ${isMobile ? "calendar-border" : ""}`}>
      <div styleName="calendar-header">
        <div styleName={`calendar-header-name ${isMobile ? "line-height-5" : ""}`}>মাস</div>
        <div styleName={`calendar-header-name ${isMobile ? "line-height-5" : ""}`}>তারিখ</div>
      </div>
      <div styleName="calendar-body">
        <div styleName="calendar-month">{renderMonth()}</div>
        <div styleName="calendar-day" id="calendar-day">
          {renderDays()}
        </div>
      </div>
    </div>
  );
};

Calendar.propTypes = {
  setDateParams: PropTypes.func,
  dialogueShow: PropTypes.func,
  isMobile: PropTypes.bool,
  dateParams: PropTypes.string,
};

const mapStateToProps = (state) => ({
  dateParams: state.dateParams,
});

const mapDispatchToProps = (dispatch) => ({
  setDateParams: (date) => dispatch(setDateParams(date)),
  dialogueShow: (show) => dispatch(dialogueShow(show)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
